<template lang="pug">
  .wrap
    .panel(v-loading='loading')
      h4.subtitle Reset your password

      transition-group(name='el-fade-in' mode='out-in')
        div(v-if='!completed' key='step1')
          p Please enter your new password:

          el-alert.error-alert(v-if="error" type="error" title="Your verification code is invalid" show-icon :closable="false")

          change-user-password-form(:change-password='changePassword' ref='changePasswordForm' :show-notify='false')

          .form-actions
            el-button(type="primary" @click='submit' size='large') Change password
            router-link(:to='{ name: "login" }' :style='{ marginLeft: "10px" }')
              el-button(type="text") Cancel

        div(v-else key='step2')
          .completed
            h3 Your password has been updated. Click on the button below to log in with your new password.

            .completed-actions
              router-link(:to='{ name: "login" }')
                el-button(type="primary") Log In


</template>

<script>
import _ from "lodash";
import { mapActions } from "vuex";
import ChangeUserPasswordForm from "@/shared/components/ChangeUserPasswordForm";

export default {
  components: { ChangeUserPasswordForm },
  data() {
    return {
      changePassword: {
        newPassword: "",
        confirmPassword: ""
      },
      loading: false,
      completed: false,
      error: false
    };
  },
  methods: {
    ...mapActions("auth", ["resetPasswordConfirm"]),
    submit() {
      this.$refs.changePasswordForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.loading = true;
        this.error = false;

        const data = {
          newPassword1: this.changePassword.newPassword,
          newPassword2: this.changePassword.confirmPassword,
          uid: this.$route.params.encodedUserId,
          token: this.$route.params.token
        };
        this.resetPasswordConfirm({ data })
          .then(() => {
            this.loading = false;
            this.completed = true;
          })
          .catch(err => {
            this.loading = false;
            if (_.get(err, "response.status", 400)) {
              this.error = true;
            } else {
              throw err;
            }
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  height: 100%;
  background: #475669;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.title {
  margin-bottom: 10px;
}

.panel {
  background: white;
  background-image: url(../../assets/images/ethos-logo.png);
  background-size: 60px;
  background-position: 50% 5%;
  padding: 80px 20px 20px 20px;
  background-repeat: no-repeat;
  max-width: 500px;
  margin: 60px auto 0 auto;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  font-family: "gilroylight";

  h3 {
    text-align: center;
  }
  h4 {
    text-align: center;
    margin-bottom: 15px;
  }
}

.form {
  margin-top: 20px;
}

label.el-form-item__label {
  font-family: "gilroyextrabold", sans-serif;
}

input {
  font-family: "Open Sans", sans-serif;
}

.completed {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;

  h3 {
    margin-bottom: 20px;
  }
}

.completed-actions {
  margin-top: 30px;
}

.error-alert {
  margin: 10px 0;
}
</style>
